import { render, staticRenderFns } from "./courseItem.vue?vue&type=template&id=21609a63&"
import script from "./courseItem.vue?vue&type=script&lang=js&"
export * from "./courseItem.vue?vue&type=script&lang=js&"
import style0 from "./courseItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports